var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-section"},[(_vm.title)?_c('span',{staticClass:"title-section-title",class:{ 'title-section--admin': !_vm.$session.currentUser.clientId }},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subtitle)?_c('span',{staticClass:"title-section-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }